"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = connectionStatusUpdateSaga;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _connectionStatusUpdate = _interopRequireDefault(require("../actions/connectionStatusUpdate"));

var _observeEach = _interopRequireDefault(require("./effects/observeEach"));

var _setReferenceGrammarID = _interopRequireDefault(require("../actions/setReferenceGrammarID"));

var _whileConnected = _interopRequireDefault(require("./effects/whileConnected"));

var _marked =
/*#__PURE__*/
_regenerator["default"].mark(observeConnectionStatus),
    _marked2 =
/*#__PURE__*/
_regenerator["default"].mark(connectionStatusUpdateSaga);

function observeConnectionStatus(_ref) {
  var directLine;
  return _regenerator["default"].wrap(function observeConnectionStatus$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          directLine = _ref.directLine;
          _context2.next = 3;
          return (0, _observeEach["default"])(directLine.connectionStatus$,
          /*#__PURE__*/
          _regenerator["default"].mark(function updateConnectionStatus(connectionStatus) {
            return _regenerator["default"].wrap(function updateConnectionStatus$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return (0, _effects.put)((0, _connectionStatusUpdate["default"])(connectionStatus));

                  case 2:
                    _context.next = 4;
                    return (0, _effects.put)((0, _setReferenceGrammarID["default"])(directLine.referenceGrammarId));

                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            }, updateConnectionStatus);
          }));

        case 3:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked);
}

function connectionStatusUpdateSaga() {
  return _regenerator["default"].wrap(function connectionStatusUpdateSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _whileConnected["default"])(observeConnectionStatus);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked2);
}